import React, { useState, useEffect } from "react";
import card from "../Assets/card.png";
import { loadStripe } from "@stripe/stripe-js";
import Joi from "joi";
import CheckoutForm from "./CheckoutForm";
import { Elements, PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { createweb, USERPROFILECLICK } from "../API/api_endpoints";
import API from "../API/urlConstants";
import { CircularProgress, TextField } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";

const amountOptions = [10, 15, 20];

const PaymentOptions = ({ fullName, email, userDetails }) => {
  const navigate = useNavigate();
  const [stripePromise, setStripePromise] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [amountValidationError, setAmountValidationError] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null );
  const [cardClientSecret, setCardClientSecret] = useState(null);
  const [walletClientSecret, setWalletClientSecret] = useState(null);
    const [token, setToken] = useState(false)
  
  const [checkout, setCheckout] = useState(false);
  const [isCircularLoading, setIsCircularLoading] = useState(false);
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [loader, setLoader] = useState(true);
  const [message, setMessage] = useState(null);
  const [isPaymentRequestSupported, setIsPaymentRequestSupported] = useState(false);
  const [isApplePaySupported, setIsApplePaySupported] = useState(false);
  const [isGooglePaySupported, setIsGooglePaySupported] = useState(false);
  const [disabledPaymentButton, setDisabledPaymentButton] = useState({
    card: false,
    us_bank_account: false,
    apple_pay: false,
    google_pay: false,
  });
  const [fees, setFees] = useState({
    card: "3.0%+$0.50",
    bank: "3.0%+$0.50",
    applePay: "3.0%+$0.50",
    googlePay: "2.9%+$0.30",
  });
  useEffect(() => {
    const initializeStripe = async () => {
      const stripe = await loadStripe("pk_test_51NhHNZFDxlsdZq5eQisMgNxM7vDvVG9SO0Le60jOpQa6KwSxbu9xiP9D8B5oyUQrbn25bu6SBlNhedgMWgSkwaDq00KXlVG4TR");
      setStripePromise(stripe);

      if (!stripe) return;
      const paymentIntentRes = await fetch(API.CREATE_PAYMENT_INTENT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer guest",
        },
        body: JSON.stringify({
          
            "piDescription": "cardToWallet",
            "metadata": {
                "getThanksUserID": "675028d962ab383de3b99a31",
                "title": "Tip to",
                "guestName": fullName,
                "email": email,
                "amountAfterFee": selectedAmount
            },
            "platformFeeForWallet": "0.80",
            "amount": selectedAmount,
            "payment_method_types": [
                "card",
                "apple_pay",
            ]
        
        }),
      });

      const data = await paymentIntentRes.json();
      setWalletClientSecret(data?.data?.paymentIntent);

      const paymentRequest = stripe.paymentRequest({
        country: "US",
        currency: "usd",
        total: {
          label: "Total Amount",
          amount: selectedAmount ? selectedAmount * 100 : 0, // Convert to cents
        },
        requestPayerName: true,
        requestPayerEmail: true,
        supportedPaymentMethods: [
          {
            supportedMethods: "apple-pay",
            data: {
              merchantIdentifier: "merchant.com.yourcompany",
              supportedNetworks: ["visa", "mastercard", "amex"],
              countryCode: "US",
              currencyCode: "usd",
            },
          },
          {
            supportedMethods: "google-pay",
            data: {
              countryCode: "US",
              currencyCode: "usd",
              environment: "TEST",
              apiVersion: 2,
              apiVersionMinor: 0,
              merchantInfo: {
                merchantName: "Your Company",
                merchantId: "BCR2DN4TQPP5TEQW",
              },
              allowedPaymentMethods: [
                {
                  type: "CARD",
                  parameters: {
                    allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                    allowedCardNetworks: ["VISA", "MASTERCARD"],
                  },
                  tokenizationSpecification: {
                    type: "PAYMENT_GATEWAY",
                    parameters: {
                      gateway: "stripe",
                      "stripe:version": "2020-08-27",
                    },
                  },
                },
              ],
            },
          },
        ],
      });

      const result = await paymentRequest.canMakePayment();
      console.log({result})
      // alert(result)
      if (result) {
        setLoader(false)
        setPaymentRequest(paymentRequest);
        setIsApplePaySupported(result.applePay ?? false);
        setIsGooglePaySupported(result.googlePay ?? false);
      }

    };

    initializeStripe();
  }, []);
  const handlePaymentClickCard = async (
    paymentMethod
  ) => {
    if(token){

    
    const amountSchema = Joi.number().integer().min(0).required();
    const { error } = amountSchema.validate(selectedAmount);

    if (error) {
      setAmountValidationError("Please enter a valid amount.");
      return;
    }

    if (!stripePromise || !selectedAmount || !paymentMethod) {
      console.error(
        "Missing required information: amount or card payment method"
      );
      return;
    }

    let reviewTitle = fullName + " " + "Tip to" + " " + userDetails?.fullName;
    const IdVal = localStorage.getItem("userid");
    const paymentData = {
      piDescription: "cardToWallet",
      metadata: {
        getThanksUserID: IdVal,
        title:
          userDetails?.businessType === "NON-PROFIT" ? "donated to" : "Tip to",
        guestName: fullName,
        userName:fullName,
        email: email,
        amountAfterFee: selectedAmount,
      },
      userName:fullName,

      platformFeeForWallet: calculatePlatformFee(
        selectedAmount,
        paymentMethod === "card" || paymentMethod === "apple_pay"
          ? fees.card
          : fees.bank,
        paymentMethod
      ),
      amount:paymentMethod === "apple_pay"?removeDollarSign(fees?.applePay): selectedAmount,      ...(userDetails?.businessType === "NON-PROFIT" && {
        userId: IdVal,
        ngoId: IdVal,
        isRecurring: false,
      }),
    };

    console.log({paymentData})

    const formData =
      paymentMethod === "apple_pay"
        ? {
            ...paymentData,
            payment_method_types: [
              "card",
              "apple_pay",
              "cash_app",
            ],
          }
        : paymentMethod === "google_pay"
        ? { ...paymentData, payment_method_types: ["card"] }
        : { ...paymentData, paymentMethodType: paymentMethod };
   

    if (userDetails?.businessType === "NON-PROFIT") {
      const response = await fetch(API.CREATE_DONATION_INTENT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer guest",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      paymentMethod==="card"?  setCardClientSecret(data?.data?.paymentIntent): setWalletClientSecret(data?.data?.paymentIntent)
      // setClientSecret(data?.data?.paymentIntent);
      setCheckout(true);
      navigate(`/user_profile/${IdVal}`);
    } else {
      const response = await fetch(API.CREATE_PAYMENT_INTENT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer guest",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      // setClientSecret(data?.data?.paymentIntent);
      paymentMethod==="card"?  setCardClientSecret(data?.data?.paymentIntent): setWalletClientSecret(data?.data?.paymentIntent)
      setCheckout(true);
      navigate(`/user_profile/${IdVal}`);
   
    }}else{
      alert("invalid Captcha")
    }
  };

  useEffect(() => {
    if (
      paymentRequest &&
      selectedAmount &&
      (fees?.googlePay || fees?.applePay)
    ) {
      try {
        const amount = fees.googlePay
          ? removeDollarSignAndConvert(fees.googlePay) * 100
          : removeDollarSignAndConvert(fees.applePay) * 100;
        if (!isNaN(amount) && amount > 0) {
          paymentRequest.update({
            total: {
              label: "Total Amount",
              amount: Math.round(amount),
            },
          });
        }
      } catch (error) {
        console.error("Error updating payment request:", error);
      }
    }
  }, [selectedAmount, paymentRequest, fees?.googlePay, fees?.applePay]);
  function removeDollarSignAndConvert(input) {
    const numberString = input.replace('$', '');
    // alert(numberString)
    return parseFloat(numberString);
}
  const calculateFeesForAllPaymentMethods = (amount) => {
    if (amount) {
      const cardFees = calculateAmountAfterFees(amount);
      const bankFees = calculateBankAmountAfterFees(amount);
      const applePayFees = calculateAmountAfterFees(amount);
      const googlePayFees = calculateAmountAfterFees(amount);
      setFees({
        card: `$${cardFees}`,
        bank: `$${bankFees}`,
        applePay: `$${applePayFees}`,
        googlePay: `$${googlePayFees}`,
      });
    }
  };

  useEffect(() => {
    calculateFeesForAllPaymentMethods(selectedAmount);
  }, [selectedAmount]);

  const handleAmountChange = (value) => {
    const inputValue = parseInt(value);
    if (!isNaN(inputValue)) {
      // alert("p")
      setSelectedAmount(inputValue);
      setAmountValidationError(null);
    } else {
      setSelectedAmount(null);
      setAmountValidationError("Please enter a valid amount.");
    }
    setCheckout(false);
    setDisabledPaymentButton({
      card: false,
      us_bank_account: false,
      apple_pay: false,
      google_pay: false,
    });
  };
  
  const handleAmountButtonClick = (amount) => {
    setSelectedAmount(amount);
    setAmountValidationError(null);
  };

  const calculatePlatformFee = (amount, feeString, mode) => {
    if (!feeString?.includes("fee")) {
      const numericFeeMatch = feeString.match(/([\d\.]+)/);

      if (numericFeeMatch) {
        const numericFee = parseFloat(numericFeeMatch[1]);
        const fees = numericFee - amount;
        return fees.toFixed(2).toString();
      }
    } else {
      const percentageMatch = feeString.match(/(\d+(\.\d+)?)%/);
      const fixedFeeMatch = feeString.match(/\$([\d\.]+)/);

      const percentage = percentageMatch ? parseFloat(percentageMatch[1]) : 0;
      const fixedFee = fixedFeeMatch ? parseFloat(fixedFeeMatch[1]) : 0;

      const percentageFee = (percentage / 100) * amount;
      const totalFee = percentageFee + fixedFee;

      return totalFee.toFixed(2);
    }
    return "0.00";
  };

  function calculateAmountAfterFees(amount) {
    const stripePercent = 2.9 / 100;
    const stripeFixedFee = 0.3;
    const appPercent = 0.1 / 100;
    const appFixedFee = 0.2;
    const stripeFees = amount * stripePercent + stripeFixedFee;
    const appFees = amount * appPercent + appFixedFee;
    const totalFees = stripeFees + appFees;
    const amountAfterFees = Number(amount) + totalFees;
    return amountAfterFees.toFixed(2);
  }


  const calculateGooglepayFees = (amount) => {
    const stripePercent = 2.9 / 100;
    const stripeFixedFee = 0.3;
    const googlePayFees = amount * stripePercent + stripeFixedFee;
    const totalAmount = Number(amount) + googlePayFees;
    return totalAmount.toFixed(2); // Return total amount with fees
  };
  const calculateBankAmountAfterFees = (paymentAmount) => {
    const stripeFeePercentage = 0.8 / 100;
    const appFeePercentage = 0.2 / 100;

    const stripeFees = paymentAmount * stripeFeePercentage;
    const appFees = paymentAmount * appFeePercentage;
    let totalFees = stripeFees + appFees;

    if (totalFees > 10) {
      totalFees = 10;
    }
    const amountAfterFees = Number(paymentAmount) + totalFees;
    return amountAfterFees.toFixed(1);
  };
  const checkPaymentIntentStatus = async (clientSecret) => {
    try {
      if (!clientSecret) {
        console.error("No clientSecret provided.");
        return null;
      }
  
      // Extract the PaymentIntent ID from clientSecret
      const paymentIntentId = clientSecret.split("_secret")[0];
  
      const response = await fetch(`https://api.stripe.com/v1/payment_intents/${paymentIntentId}`, {
        method: "GET",
        headers: {
          // "Authorization": `Bearer ${STRIPE_SECRET_KEY}`,  // Your Stripe secret key
          "Content-Type": "application/json",
        },
      });
  
      const intentData = await response.json();
  
      if (response.ok) {
        console.log("✅ PaymentIntent Status:", intentData?.status);
        return intentData?.status; // should be "requires_payment_method" before confirming
      } else {
        console.error("❌ Failed to retrieve PaymentIntent:", intentData.error);
        return null;
      }
    } catch (error) {
      console.error("❌ Error fetching PaymentIntent:", error);
      return null;
    }
  };
  
  const handlePaymentClick = async (paymentMethod) => {
    // Validate selectedAmount using Joi schema
    const amountSchema = Joi.number().integer().min(0).required();
    const { error } = amountSchema.validate(selectedAmount);
  
    if (error) {
      setAmountValidationError("Please enter a valid amount.");
      return;
    }
  
    if (!stripePromise || !selectedAmount || !paymentMethod) {
      console.error("❌ Missing required information: amount or payment method");
      return;
    }
  
    const stripe = await stripePromise;
    const IdVal = localStorage.getItem("userid");
  
    let reviewTitle = `${fullName} Tip to ${userDetails?.fullName}`;
  
    // Prepare payment data
    const paymentData = {
      piDescription: "cardToWallet",
      metadata: {
        getThanksUserID: IdVal,
        title: userDetails?.businessType === "NON-PROFIT" ? "donated to" : "Tip to",
        guestName: fullName,
        email: email,
        amountAfterFee: selectedAmount,
      },
      userName:fullName,

      platformFeeForWallet: calculatePlatformFee(
        selectedAmount,
        ["card", "apple_pay","google_pay"].includes(paymentMethod) ? fees.card : fees.bank,
        paymentMethod
      ),
      amount: paymentMethod === "apple_pay" ? removeDollarSign(fees?.applePay) : selectedAmount,
      ...(userDetails?.businessType === "NON-PROFIT" && {
        userId: IdVal,
        ngoId: IdVal,
        isRecurring: false,
      }),
    };
  
    console.log("🔹 Payment Data:", paymentData);
  
    // Prepare form data for API request
    const formData = {
      ...paymentData,
      payment_method_types: 
        paymentMethod === "apple_pay"
          ? ["card", "apple_pay", "cash_app"]
          : paymentMethod === "google_pay"
          ? ["card"]
          : [paymentMethod],
    };
  
    try {
      // 🔹 Create Payment Intent
      const response = await fetch(API.CREATE_PAYMENT_INTENT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer guest",
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
  
      if (!response.ok || !data?.data?.paymentIntent) {
        console.error("❌ Payment Intent creation failed:", data);
        setMessage("Payment could not be processed. Please try again.");
        return;
      }
  
      const clientSecret = data.data.paymentIntent;
      setWalletClientSecret(clientSecret);
  
      // 🔹 Handle Apple Pay & Google Pay via Payment Request API
      if (paymentMethod === "apple_pay" || paymentMethod === "google_pay") {
        if (!paymentRequest) {
          console.error("❌ PaymentRequest is not initialized.");
          return;
        }
  
        const handlePaymentMethod = async (event) => {
          try {
            const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
              payment_method: event.paymentMethod.id,
              
            });
  
            if (error) {
              console.error("❌ Payment Failed:", error.message);
              setMessage(error.message);
              event.complete("fail"); // Notify browser of failure
            } else {
              if (paymentIntent.status === "succeeded") {
                setMessage(paymentIntent.status);
         
                event.complete("success");
            
                // Wait a moment before navigating to ensure the modal opens first
                setTimeout(() => {
                  window.location.href=`/user_profile/${localStorage.getItem("userid")}?payment_intent=""&payement_client=""&redirect_status=succeeded`                }, 1000);
           
              } else {
                setMessage("Payment failed or incomplete.");
              }
            }
          } catch (error) {
            console.error("❌ Error confirming payment:", error);
            setMessage("An error occurred. Please try again.");
            event.complete("fail");
          }
        };
  
        paymentRequest.on("paymentmethod", handlePaymentMethod);
  
        return () => {
          paymentRequest.off("paymentmethod", handlePaymentMethod);
          setMessage("paymentIntent.status1");
        };
      }
  
    } catch (error) {
      console.error("❌ Error processing payment:", error);
      setMessage("Something went wrong. Please try again.");
    }
  };
  
  
  
console.log({paymentMethod},fees?.applePay,fees?.googlePay)

function removeDollarSign(input) {
  return input.replace('$', '');
}
  useEffect(() => {
    const fetchData = async () => {
      const formData = {
        email: email,
        fullName: fullName,
      };

      try {
        const response = await createweb(formData);
        console.log(response?.data, "data");
        if (response?.data?.userId) {
          const IdVal = localStorage.getItem("userid");

          const formDataVal = {
            userProfileId: IdVal,
            profileClickBy: response?.data?.userId,
            guestName: fullName,
          };
          try {
            const response = USERPROFILECLICK(formDataVal).then((response) =>
              console.log(response, "data")
            );

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
          } catch (error) {
            console.error("Error creating Payment Intent:", error);
           
          }
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Payment Intent created successfully:", data);
      } catch (error) {
        console.error("Error creating Payment Intent:", error);
      }
    };

    fetchData();
  }, [navigate]);

  // Define payment methods here
  const paymentMethods = [
    {
      src: card,
      label: "Pay via Debit/Credit Card",
      value: "card",
      amount: selectedAmount ? fees.card : "3.0%+$0.50",
    },
  ];

  const sectionRef = React.useRef(null);

  const handleScroll = () => {
    setTimeout(() => {
      if (sectionRef.current) {
        sectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 2000); //
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (!stripePromise || !cardClientSecret) {
      setMessage("Stripe is not initialized or clientSecret is missing.");
      return;
    }
  
    setIsCircularLoading(true);
  
    try {

      const elements = stripePromise.elements();
  
      if (!elements) {
        setMessage("Stripe elements are not available.");
        setIsCircularLoading(false);
        return;
      }
  
      // const paymentElement = elements.getElement(PaymentElement);
      // if (!paymentElement) {
      //   setMessage("Payment Element not found. Please check form rendering.");
      //   setIsCircularLoading(false);
      //   return;
      // }
  
      const { error, paymentIntent } = await stripePromise.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${API.WEB_STAGING_URL}/${localStorage.getItem("userid")}`,
        },
      });
  
      if (error) {
        setMessage(error.message);
      } else if (paymentIntent?.status === "succeeded") {
        setMessage("Payment successful!");
        navigate(`/user_profile/${localStorage.getItem("userid")}`);
      } else {
        setMessage("Unexpected payment status.");
      }
    } catch (error) {
      console.error("Stripe Payment Error:", error);
      setMessage(`Something went wrong: ${error.message || error.toString()}`);
    }
  
    setIsCircularLoading(false);
  };
  
  function handleOnChange(value) {
    setToken(value)
  }
  return (
    <div className="w-full flex flex-col text-center px-[2rem] pb-8 gap-4 relative z-[100000]">
      <div className="flex flex-col gap-8">
        <div className="flex flex-row flex-wrap justify-between gap-2">
          {amountOptions.map((item) => (
            <button
              key={item}
              className={`h-[3.125rem] w-[28%] flex border border-[#979797] rounded-[0.625rem] justify-center border-opacity-[30%] items-center ${
                selectedAmount === item ? "bg-[#e0e0e0]" : ""
              }`}
              value={item}
              onClick={() => {
                if (!loader) {
                  handleAmountButtonClick(item);
                }
              }}
            >
              <p className="text-[#979797] text-base font-medium">{`$${item}`}</p>
            </button>
          ))}
        </div>

        <div className="flex flex-col gap-2 w-full ">
        <TextField
  type="number"
  id="amount"
  min={0}
  step={1}
  placeholder="Other (in Dollars)"
  value={selectedAmount || ""}
  onChange={(e) => {
    let value = e.target.value.replace(/\D/g, "").slice(0, 6);
    handleAmountChange(value);
}} 
 onKeyPress={(e) => {
    if (e.key === "." || e.key === "," || e.key === "e") {
      e.preventDefault(); // Prevent typing "." "," and "e"
    }
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form-like behavior on iOS
    }
  }}
  onPaste={(e) => {
    const pastedData = e.clipboardData.getData("text");
    if (!/^\d+$/.test(pastedData)) {
      e.preventDefault(); // Prevent non-numeric values from being pasted
    }
  }}
  sx={{
    width: "100%",
    fontWeight: "300", // Tailwind's font-light
    fontSize: "1rem",  // Tailwind's text-base
    "& .MuiOutlinedInput-root": {
      borderRadius: "0.625rem", // Tailwind's rounded-[0.625rem]
      "&:hover fieldset": {
        borderColor: amountValidationError ? "#EF4444" : undefined, // Tailwind's border-red-500
      },
      "&.Mui-focused fieldset": {
        borderColor: amountValidationError ? "#EF4444" : undefined,
      },
    },
    "& input[type=number]": {
      MozAppearance: "textfield", // Remove spinner arrows in Firefox
    },
    "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
      WebkitAppearance: "none", // Remove spinner arrows in Chrome/Safari
      margin: 0,
    },
  }}
  inputProps={{
    inputMode: "numeric", // Mobile-friendly numeric keyboard
  }}
/>
{amountValidationError && (
  <p className="w-full self-start text-red-500 text-sm text-left">
    {amountValidationError}
  </p>
)}

        
        </div>
      </div>
      {console.log(disabledPaymentButton, "disabledPymentButton")}
    
   <div ref={sectionRef}>
  {loader ? (
    <CircularProgress />
  ) : (
    <> 
      <ReCAPTCHA
        sitekey="6LcU5i8rAAAAAJJA5AKMoeYjXc7K9r2fBa3lZ68V"
        onChange={handleOnChange}
      />
     {token &&paymentMethods?.map((items) => {
      return (
        <div key={items.value}>
          <button
            className={`w-full flex justify-center border-[1px] border-[#979797] rounded-[0.625rem] border-opacity-[30%] h-[3.125rem] flex items-center gap-1 p-[0.625rem] ${
              selectedAmount && disabledPaymentButton[items.value]
                ? "bg-[#e0e0e0] border-[#000000]"
                : "bg-white"
            } `}
            // disabled={selectedAmount && disabledPaymentButton[items.value]}
            onClick={() => {
             
              handleScroll();
              if (selectedAmount) {
                
                setPaymentMethod(items?.value);
                handlePaymentClickCard(
                  "card"
                );
                setDisabledPaymentButton({
                  card: items.value === "card",
               
                  apple_pay: items.value === "apple_pay",
                  google_pay:items.value === "google_pay"
                });
              } else {
                setAmountValidationError(
                  "Please enter an amount before proceeding"
                );
              }
            }}
          >
            <img
              src={items.src}
              alt=""
              className={`${
                items.value === "google_pay" ? "h-[3rem]" : "h-[1.5rem]"
              } w-[1.5rem] `} 
              style={{
                filter: selectedAmount && disabledPaymentButton.google_pay ? 'contrast(0.75)' : undefined
              }}
              
            />
            <p
              className={`text-[#1D1546] font-medium text-sm ${
                items.value === "apple_pay" || items.value === "google_pay"
                  ? "text-[1.2rem] font-bold"
                  : "text-sm"
              }`}
            >
              {items.label}
            </p>
          </button>
          {items.value === "apple_pay" ||
          items.value === "google_pay" ? null : (
            <p className="w-full self-start text-green-700 text-sm text-left mt-2 mb-2">
              {`You will be charged ${items.amount}`}
            </p>
          )}
        </div>
      );
    })}
   { stripePromise && (
      <>
        {/* Wallet PaymentRequest */}
        {isApplePaySupported  &&  token &&(
          <>
          <Elements stripe={stripePromise} >
            <PaymentRequestButtonElement
              options={{ paymentRequest }}
              onClick={(event) => {
                if (!selectedAmount || isNaN(selectedAmount) || selectedAmount <= 0) {
                  event.preventDefault();
                  setMessage("Please enter a valid amount greater than 0.");
                } else {
                 
                  setPaymentMethod("apple_pay");
                  handlePaymentClick("apple_pay")
                }
              }}
              disabled={!selectedAmount || isNaN(selectedAmount) || selectedAmount <= 0}
            />
          </Elements>
          <p className="w-full self-start text-green-700 text-sm text-left mt-2 mb-2">
          {`You will be charged ${fees.applePay}`}
        </p></>
        )}


         {isGooglePaySupported  && token && (
         <> <Elements stripe={stripePromise} >
            <PaymentRequestButtonElement
              options={{ paymentRequest }}
              onClick={(event) => {
                if (!selectedAmount || isNaN(selectedAmount) || selectedAmount <= 0) {
                  event.preventDefault();
                  setMessage("Please enter a valid amount greater than 0.");
                } else {
                  setPaymentMethod("google_pay");
                  handlePaymentClick("google_pay")
                }
              }}
              disabled={!selectedAmount || isNaN(selectedAmount) || selectedAmount <= 0}
            />
          </Elements>

</>
        )}
      {isGooglePaySupported ?
                      
                      <p className="w-full self-start text-green-700 text-sm text-left">
                        {`You will be charged ${selectedAmount ? fees.card : "3.0%+$0.50"}`}
                      </p>:null
                    }
        {/* Card Payment */}
        {paymentMethod === "card" && cardClientSecret && (
         <Elements stripe={stripePromise} options={{ clientSecret: cardClientSecret }}>
            <CheckoutForm clientSecret={cardClientSecret} amount={selectedAmount} />

       </Elements>
        )}
      </>
    )}</>
  )}
  { message ==="succeeded"  ?<p className="text-green-500 mt-2 capitalize">{message}</p>:<p className="text-red-500 mt-2">{message}</p>}
</div>

    </div>
  );
};

export default PaymentOptions;

/**import React, { useState, useEffect, useRef } from "react";
import bank from "../Assets/bank.png";
import card from "../Assets/card.png";
import applePay from "../Assets/applePayIcon.png";
import { loadStripe } from "@stripe/stripe-js";
import Joi from "joi";
import CheckoutForm from "./CheckoutForm";
import { Elements } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { createweb, USERPROFILECLICK } from "../API/api_endpoints";
import API from "../API/urlConstants";
import { CircularProgress } from "@mui/material";
import { isAndroid } from "react-device-detect";

const amountOptions = [10, 15, 20];

const PaymentOptions = ({ fullName, email, userDetails }) => {
  const navigate = useNavigate();
  const [stripePromise, setStripePromise] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [amountValidationError, setAmountValidationError] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [clientSecret, setClientSecret] = useState(null);
  const [checkout, setCheckout] = useState(false);
  const [loader, setLoader] = useState(false);

  const [disabledPaymentButton, setDisabledPaymentButton] = useState({
    card: false,
    us_bank_account: false,
    apple_pay: false,
  });
  const [fees, setFees] = useState({
    card: "3.0%+$0.50",
    bank: "1.00%",
    applePay: "3.0%+$0.50",
  });

  useEffect(() => {
    const loadStripeAsync = async () => {
      const stripe = await loadStripe(
        "pk_test_51NhHNZFDxlsdZq5eQisMgNxM7vDvVG9SO0Le60jOpQa6KwSxbu9xiP9D8B5oyUQrbn25bu6SBlNhedgMWgSkwaDq00KXlVG4TR"
      );
      setStripePromise(stripe);
    };

    loadStripeAsync();
  }, []);

  const calculateFeesForAllPaymentMethods = (amount) => {
    if (amount) {
      const cardFees = calculateAmountAfterFees(amount);
      const bankFees = calculateBankAmountAfterFees(amount);
      const applePayFees = calculateAmountAfterFees(amount);

      setFees({
        card: `$${cardFees}`,
        bank: `$${bankFees}`,
        applePay: `$${applePayFees}`,
      });
    }
  };

  useEffect(() => {
    calculateFeesForAllPaymentMethods(selectedAmount);
  }, [selectedAmount]);

  const handleAmountChange = (event) => {
    const inputValue = parseInt(event?.target?.value);
    if (!isNaN(inputValue)) {
      setSelectedAmount(inputValue);
      setAmountValidationError(null);
    } else {
      setSelectedAmount(null);
      setAmountValidationError("Please enter a valid amount.");
    }
    setCheckout(false);
    setDisabledPaymentButton({
      card: false,
      us_bank_account: false,
      apple_pay: false,
    });
  };

  const handleAmountButtonClick = (amount) => {
    setSelectedAmount(amount);
    setAmountValidationError(null);
  };

  const calculatePlatformFee = (amount, feeString, mode) => {
    if (!feeString?.includes("fee")) {
      const numericFeeMatch = feeString.match(/([\d\.]+)/);

      if (numericFeeMatch) {
        const numericFee = parseFloat(numericFeeMatch[1]);
        const fees = numericFee - amount;
        return fees.toFixed(2).toString();
      }
    } else {
      const percentageMatch = feeString.match(/(\d+(\.\d+)?)%/);
      const fixedFeeMatch = feeString.match(/\$([\d\.]+)/);

      const percentage = percentageMatch ? parseFloat(percentageMatch[1]) : 0;
      const fixedFee = fixedFeeMatch ? parseFloat(fixedFeeMatch[1]) : 0;

      const percentageFee = (percentage / 100) * amount;
      const totalFee = percentageFee + fixedFee;

      return totalFee.toFixed(2);
    }
    return "0.00";
  };

  function calculateAmountAfterFees(amount) {
    const stripePercent = 2.9 / 100;
    const stripeFixedFee = 0.3;
    const appPercent = 0.1 / 100;
    const appFixedFee = 0.2;
    // Calculate Stripe fees
    const stripeFees = amount * stripePercent + stripeFixedFee;
    // Calculate app fees
    const appFees = amount * appPercent + appFixedFee;
    // Calculate the total fees
    const totalFees = stripeFees + appFees;
    const amountAfterFees = Number(amount) + totalFees;
    return amountAfterFees.toFixed(1);
  }

  const calculateBankAmountAfterFees = (paymentAmount) => {
    const stripeFeePercentage = 0.8 / 100;
    const appFeePercentage = 0.2 / 100;

    const stripeFees = paymentAmount * stripeFeePercentage;
    const appFees = paymentAmount * appFeePercentage;
    let totalFees = stripeFees + appFees;

    if (totalFees > 10) {
      totalFees = 10;
    }
    const amountAfterFees = Number(paymentAmount) + totalFees;
    return amountAfterFees.toFixed(1);
  };

  const handlePaymentClick = async (
    stripePromise,
    selectedAmount,
    paymentMethod
  ) => {
    setLoader(true);
    const amountSchema = Joi.number().integer().min(0).required();
    const { error } = amountSchema.validate(selectedAmount);

    if (error) {
      setAmountValidationError("Please enter a valid amount.");
      return;
    }

    if (!stripePromise || !selectedAmount || !paymentMethod) {
      console.error(
        "Missing required information: amount or card payment method"
      );
      return;
    }

    let reviewTitle = fullName + " " + "Tip to" + " " + userDetails?.fullName;

    const IdVal = localStorage.getItem("userid");
    const paymentData = {
      piDescription: "cardToWallet",
      metadata: {
        getThanksUserID: IdVal,
        title:
          userDetails?.businessType === "NON-PROFIT" ? "donated to" : "Tip to",
        guestName: fullName,
        email: email,
        amountAfterFee: selectedAmount,
      },
      platformFeeForWallet: calculatePlatformFee(
        selectedAmount,
        paymentMethod === "card" || paymentMethod === "apple_pay"
          ? fees.card
          : fees.bank,
        paymentMethod
      ),
      amount: selectedAmount,

      ...(userDetails?.businessType === "NON-PROFIT" && {
        userId: IdVal,
        ngoId: IdVal,
        isRecurring: false,
      }),
    };

    const formData =
      paymentMethod === "apple_pay"
        ? {
            ...paymentData,
            payment_method_types: ["apple_pay", "card"],
          }
        : { ...paymentData, paymentMethodType: paymentMethod };
    if (userDetails?.businessType === "NON-PROFIT") {
      const response = await fetch(API.CREATE_DONATION_INTENT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer guest",
        },
        body: JSON.stringify(formData),
      });
      setLoader(false);
      const data = await response.json();
      setClientSecret(data?.data?.paymentIntent);
      setCheckout(true);
      navigate(`/user_profile/${IdVal}`);
    } else {
      const response = await fetch(API.CREATE_PAYMENT_INTENT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer guest",
        },
        body: JSON.stringify(formData),
      });
      setLoader(false);

      const data = await response.json();
      setClientSecret(data?.data?.paymentIntent);
      setCheckout(true);
      navigate(`/user_profile/${IdVal}`);
    }
  };
console.log(clientSecret, "clientSecret")
  useEffect(() => {
    const fetchData = async () => {
      const formData = {
        email: email,
        fullName: fullName,
      };

      try {
        const response = await createweb(formData);
        console.log(response?.data, "data");
        if (response?.data?.userId) {
          const IdVal = localStorage.getItem("userid");

          const formDataVal = {
            userProfileId: IdVal,
            profileClickBy: response?.data?.userId,
            guestName: fullName,
          };
          try {
            const response = USERPROFILECLICK(formDataVal).then((response) =>
              console.log(response, "data")
            );

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            // const data = await response.json();
            // console.log('Payment Intent created successfully:', data);
            // Handle the response data here
          } catch (error) {
            console.error("Error creating Payment Intent:", error);
            // Handle any errors here
          }
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Payment Intent created successfully:", data);
      } catch (error) {
        console.error("Error creating Payment Intent:", error);
        // Handle any errors here
      }
    };

    fetchData();
  }, [navigate]);

  // Define payment methods here
  const paymentMethods = [
    {
      src: card,
      label:
        userDetails?.businessType === "NON-PROFIT"
          ? "Donate via Debit/Credit Card"
          : "Tip via Debit/Credit Card",
      value: "card",
      amount: selectedAmount ? fees.card : "3.0%+$0.50",
    },
    // {
    //   src: bank,
    //   label: "Pay via Bank",
    //   value: "us_bank_account",
    //   amount: selectedAmount ? fees.bank : "1.00%",
    // },
    // {
    //   src: applePay,
    //   label:
    //     userDetails?.businessType === "NON-PROFIT"
    //       ? "Donate via Apple Pay"
    //       : "Tip via Apple Pay",
    //   value: "apple_pay",
    //   amount: selectedAmount ? fees.applePay : "3.0%+$0.50",
    // },
  ];
  const sectionRef = React.useRef(null);

  const handleScroll = () => {
    setTimeout(() => {
      if (sectionRef.current) {
        sectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 2000); //
  };
  useEffect(() => {
    if (loader) {
      handleScroll();
    }
  }, [loader]);
  return (
    <div className="w-full flex flex-col text-center px-[2rem] pb-8 gap-4 relative z-[100000]">
      <div className="flex flex-col gap-8">
        <div className="flex flex-row flex-wrap justify-between gap-2">
          {amountOptions.map((item) => (
            <button
              key={item}
              className={`h-[3.125rem] w-[28%] flex border border-[#979797] rounded-[0.625rem] justify-center border-opacity-[30%] items-center ${
                selectedAmount === item ? "bg-[#e0e0e0]" : ""
              }`}
              value={item}
              onClick={() => {
                handleAmountButtonClick(item);
              }}
            >
              <p className="text-[#979797] text-base font-medium">{`$${item}`}</p>
            </button>
          ))}
        </div>

        <div className="flex flex-col gap-2 w-full ">
          <input
            onKeyPress={(e) => {
              if (e.key === "." || e.key === "," || e.key === "e") {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const pastedData = e.clipboardData.getData("text");
              if (
                pastedData.includes(".") ||
                pastedData.includes(",") ||
                isNaN(pastedData)
              ) {
                e.preventDefault();
              }
            }}
            type="number"
            id="amount"
            min={0}
            step={1}
            className={`w-full border-[1px] border-[#979797] rounded-[0.625rem] border-opacity-[30%] font-light h-[3.125rem] text-base p-[0.625rem] ${
              amountValidationError ? "border-red-500" : ""
            }`}
            placeholder="Other (in Dollars)"
            value={selectedAmount || ""}
            onChange={handleAmountChange}
          />
          {amountValidationError && (
            <p className="w-full self-start  text-red-500 text-sm text-left">
              {amountValidationError}
            </p>
          )}
        </div>
      </div>
      {loader
        ? null
        : paymentMethods
            .filter((item) => !(isAndroid && item.value === "apple_pay"))
            .map((items) => {
              return (
                <div key={items.value}>
                  <button
                    className={`w-full border-[1px] border-[#979797] rounded-[0.625rem] border-opacity-[30%] h-[3.125rem] flex items-center gap-2 p-[0.625rem] cursor-pointer ${
                      selectedAmount && disabledPaymentButton[items.value]
                        ? "bg-[#e0e0e0] border-[#000000]"
                        : "bg-white"
                    }`}
                    disabled={
                      selectedAmount && disabledPaymentButton[items.value]
                    }
                    onClick={() => {
                      handleScroll();
                      if (selectedAmount) {
                        setPaymentMethod(items?.value);
                        handlePaymentClick(
                          stripePromise,
                          selectedAmount,
                          items?.value
                        );
                        setDisabledPaymentButton({
                          card: items.value === "card",
                          us_bank_account: items.value === "us_bank_account",
                          apple_pay: items.value === "apple_pay",
                        });
                      } else {
                        setAmountValidationError(
                          "Please enter an amount before proceeding"
                        );
                      }
                    }}
                  >
                    <img
                      src={items.src}
                      alt=""
                      className="w-[1.5rem] h-[1.5rem]"
                    />
                    <p className="text-[#1D1546] font-medium text-sm">
                      {items.label}
                    </p>
                  </button>
                  <p className="w-full self-start text-green-700 text-sm text-left">
                    {`You will be charged ${items.amount}`}
                  </p>
                </div>
              );
            })}

      {loader ? (
        <div>
          {" "}
          <CircularProgress
            sx={{
              color: "rgb(255 111 41)",
              width: "30px !important",
              height: "30px !important ",
            }}
          />
        </div>
      ) : (
        <div ref={sectionRef}>
          {stripePromise && clientSecret && checkout ? (
            <Elements
              stripe={stripePromise}
              key={clientSecret}
              options={{ clientSecret }}
            >
              <CheckoutForm
                amount={selectedAmount}
                stripe={stripePromise}
                options={{ clientSecret }}
                clientSecret={clientSecret}
              />
            </Elements>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PaymentOptions;
 */
